import { gql } from '@apollo/client';

export const ARCHIVE_PEOPLE = gql`
  mutation ArchivePeople($id: ID!) {
    people: archiveStakeholder(id: $id) {
      id
    }
  }
`;
